import React, { useEffect } from "react";
import Text from "components/Text";
import RadioInput from "components/RadioInput";
import { Row, Column } from "components/Layout/Grid";
import Validator from "components/Validator";
import { IRemainingBalanceType } from './interface';
import Input from "components/Input";

const RemainingBalance: React.FC<IRemainingBalanceType> = (props) => {
  const {
    protocolCategory,
    remainingBalance,
    setRemainingBalance,
    qtdRemainingBalance,
    setQtdRemainingBalance,
    isEditing
  } = props;

  useEffect(() => {
    if (!isEditing) {
      setRemainingBalance(undefined);
      setQtdRemainingBalance(undefined);
    }
  }, [protocolCategory]);

  return (
    <Row className="flex-row flex-md-column">
      <Column className="mt-5 mr-lg-4">
        <Text className="mb-2 color-blue-gray" size={12}>
          Há saldo remanescente no estoque do lote reclamado?
        </Text>
        <Validator value={remainingBalance} name="Há saldo remanescente no estoque do lote reclamado" required={remainingBalance === undefined}>
          <Row className="flex-md-column">
            <Row key={0} className="w-md-100 mt-md-2 mr-4">
              <RadioInput
                id={'sim'}
                onClick={() => setRemainingBalance(true)}
                checked={remainingBalance === true}
              >
                <Text className="color-blue-gray">Sim</Text>
              </RadioInput>
            </Row>
            <Row key={0} className="w-md-100 mt-md-2 mr-4">
              <RadioInput
                id={'nao'}
                onClick={() => setRemainingBalance(false)}
                checked={remainingBalance === false}
              >
                <Text className="color-blue-gray">Não</Text>
              </RadioInput>
            </Row>
          </Row>
        </Validator>
      </Column>

      {remainingBalance && (
        <Column className="mt-5 mt-md-3 ml-4 ml-md-0">
          <Text className="mb-2 color-blue-gray" size={12}>
            Quantidade disponível em estoque
          </Text>
          <Validator value={qtdRemainingBalance} name="Quantidade disponível" required={remainingBalance && (!qtdRemainingBalance || qtdRemainingBalance === '')}>
            <Input
              stateName="qtdRemainingBalance"
              value={qtdRemainingBalance || ''}
              className="w-100"
              type="text"
              onChange={(e: any) => setQtdRemainingBalance(e.target.value)}
              placeholder="Especificar"
            />
          </Validator>
        </Column>
      )}
    </Row>
  );
};

export default RemainingBalance;
